import { translate } from "@atoms/atom-client/i18n";
import { Sides } from "@project/emerge-types";

/**
 * enumeration of the basic six directions
 * by design it is possible to get the opposing side by inverting the 1-bit
 * LEFT ^ 1 = RIGHT
 */

export const allSides: ReadonlyArray<Sides> = [
  Sides.LEFT,
  Sides.RIGHT,
  Sides.BACK,
  Sides.FRONT,
  Sides.BOTTOM,
  Sides.TOP,
];

/**
 * German side names. A name suggestion that ends up in stored data (template
 * names) uses this table, not the UI-language {@link sideNames}.
 */
export const SIDE_NAMES_DE: Readonly<Record<Sides, string>> = {
  [Sides.BACK]: "Hinten",
  [Sides.FRONT]: "Vorne",
  [Sides.LEFT]: "Links",
  [Sides.RIGHT]: "Rechts",
  [Sides.TOP]: "Oben",
  [Sides.BOTTOM]: "Unten",
};

/** Side names in the UI language (read on access). */
export const sideNames: { readonly [index: number]: string } = {
  get [Sides.BACK]() {
    return translate("app.manufacturer.sides.back", SIDE_NAMES_DE[Sides.BACK]);
  },
  get [Sides.FRONT]() {
    return translate(
      "app.manufacturer.sides.front",
      SIDE_NAMES_DE[Sides.FRONT],
    );
  },
  get [Sides.LEFT]() {
    return translate("app.manufacturer.sides.left", SIDE_NAMES_DE[Sides.LEFT]);
  },
  get [Sides.RIGHT]() {
    return translate(
      "app.manufacturer.sides.right",
      SIDE_NAMES_DE[Sides.RIGHT],
    );
  },
  get [Sides.TOP]() {
    return translate("app.manufacturer.sides.top", SIDE_NAMES_DE[Sides.TOP]);
  },
  get [Sides.BOTTOM]() {
    return translate(
      "app.manufacturer.sides.bottom",
      SIDE_NAMES_DE[Sides.BOTTOM],
    );
  },
};

export const getOpposingSide = (side: Sides): Sides => {
  return side ^ (1 as Sides);
};
